var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPythIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 48,
    viewBox: "0 0 142 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9767_18234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0613 28.0453V24.7975H61.755C62.9314 24.7975 63.8494 24.4631 64.5082 23.7945C65.1664 23.1258 65.496 22.2444 65.496 21.1546C65.496 20.0647 65.1664 19.1659 64.5082 18.5146C63.8494 17.8633 62.9314 17.5377 61.755 17.5377H51.6116V33.3838H48.291V14.1791H61.755C62.862 14.1791 63.8494 14.342 64.7203 14.6676C65.589 14.9933 66.3232 15.4514 66.921 16.0418C67.5189 16.6324 67.9757 17.3488 68.292 18.1933C68.6083 19.0378 68.7664 19.9887 68.7664 21.046C68.7664 22.1033 68.6083 23.0303 68.292 23.8857C67.9757 24.7389 67.5189 25.4748 66.921 26.0914C66.3232 26.708 65.5912 27.1878 64.7203 27.5308C63.852 27.8738 62.862 28.0453 61.755 28.0453H54.0613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6638 33.3795V26.0893L69.4946 14.1792H73.9998L81.4573 23.026L88.9389 14.1792H93.2079L83.0105 26.0893V33.3795H79.6638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.746 33.3795V17.5334H95.9336V14.1792H116.917V17.5334H108.092V33.3795H104.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.852 14.1794H141.185V33.3797H137.852V14.1794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.469 33.3797V25.0691H135.871V22.097H123.469V14.1794H120.135V33.3797H123.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3453 19.1995C24.3453 21.8503 22.2009 23.9996 19.5562 23.9996V28.7996C24.8456 28.7996 29.1344 24.5011 29.1344 19.1995C29.1344 13.8979 24.8456 9.5993 19.5562 9.5993C17.8125 9.5993 16.175 10.0661 14.7671 10.8845C11.9036 12.5432 9.97803 15.6455 9.97803 19.1995V43.2L14.2841 47.5157L14.7671 48V19.1995C14.7671 16.5487 16.9115 14.3994 19.5562 14.3994C22.2009 14.3994 24.3453 16.5487 24.3453 19.1995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5562 0C16.0668 0 12.7961 0.9357 9.97804 2.57046C8.17376 3.61472 6.55792 4.94554 5.18897 6.50216C2.20853 9.88671 0.399902 14.3329 0.399902 19.2003V33.6006L5.18897 38.4006V19.2003C5.18897 14.9365 7.03877 11.1047 9.97804 8.4669C11.36 7.22944 12.9823 6.25247 14.7672 5.6229C16.2639 5.08881 17.8776 4.80009 19.5562 4.80009C27.4904 4.80009 33.9234 11.2479 33.9234 19.2003C33.9234 27.1527 27.4904 33.6006 19.5562 33.6006V38.4006C30.1372 38.4006 38.7125 29.8035 38.7125 19.2003C38.7125 8.59714 30.1372 0 19.5562 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9767_18234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.786,
    height: 48,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythIcon);
export default __webpack_public_path__ + "static/media/pyth_icon.e1c97f10f8ad0481dd430bc1aa60cbaf.svg";
export { ForwardRef as ReactComponent };